import { render, staticRenderFns } from "./OrderDeliverying.vue?vue&type=template&id=d395f1fe&"
import script from "./OrderDeliverying.vue?vue&type=script&lang=ts&"
export * from "./OrderDeliverying.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports